module.exports = __webpack_public_path__ + "static/badge_best_seller-ab7eb89f046255de1c3259b6dafb39d0.gif";